import React, {Component} from 'react';
import {connect} from 'react-redux';
import {message} from 'antd';

import Admin from './Admin';
import {
    storeContractorAdmin,
    updateContractorAdmin,
    fetchContractorAdmins
} from '../../actions';

class AdminContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {admin} = nextProps;
        if (!admin) return null;

        if (admin.error) {
            return {serverErrors: admin.error}
        }
        if (!admin.error && prevState.serverErrors) {
            return {serverErrors: null}
        }
        return null;
    }
    static notifySuccess() {
        message.success('Successfully updated');
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}, props: {history}} = this;
        if (!serverErrors) {
            AdminContainer.notifySuccess();
            setTimeout(() => history.goBack(), 100);
            return;
        }

        const {res: {errors, message}} = serverErrors;
        AdminContainer.notifyError(errors || message);
    }
    componentDidMount() {
        const {
            match: {params: {admin: id}},
            contractor: {id: contractorId},
            fetchContractorAdmins,
            admin
        } = this.props;

        if (!id) return;
        !admin && fetchContractorAdmins(contractorId);
    }
    render() {
        const {storeContractorAdmin, updateContractorAdmin, contractor: {id: contractorId}, history, admin} = this.props;
        const onSubmit = (values) => {
            const fn = !admin || admin.draft ? storeContractorAdmin : updateContractorAdmin;
            const args = !admin || admin.draft ? [contractorId, values] : [contractorId, admin.id, {...values, id: admin.id}];
            return fn(...args).then(() => this.handlePostSubmit(values));
        };

        return <Admin admin={admin} onSubmit={onSubmit} onCancel={() => history.goBack()}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    // id exists for edit component
    const {match: {params: {admin: id}}} = ownProps;
    const admin = state.contractor.admins.data.find(b => id ? (b.id === +id) : b.draft);
    return {
        contractor: state.contractor.profile,
        admin
    };
};
export default connect(mapStateToProps, {
    storeContractorAdmin,
    updateContractorAdmin,
    fetchContractorAdmins
})(AdminContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/AdminContainer.js